import { useQuery } from "urql";

import {
  DeskCollectionMessageTemplateFilter,
  DeskCollectionMessageTemplateOrderBy,
  GetMessageTemplatesDocument,
} from "../../../../graphql/generated.ts";
import { ApiHookProps } from "../../types.ts";

export const useMessageTemplates = ({
  filter,
  orderBy,
  pause,
}: ApiHookProps<
  DeskCollectionMessageTemplateFilter,
  DeskCollectionMessageTemplateOrderBy
>) => {
  const variables = { filter, orderBy };
  return useQuery({ query: GetMessageTemplatesDocument, variables, pause });
};
